import * as App from "@timesheets/routes-app";

import { Reminder } from "@timesheets/constants-common";
import { RouteConfig } from "vue-router";

export const reminders: RouteConfig[] = [
  {
    path: App.Reminders.Root,
    name: Reminder.Instance.CollectionName,
    component: async () => import("@/pages/Dashboard/components/Reminders/RemindersMenuList.vue"),
  },
  {
    path: App.Reminders.Timesheets.ForSubmission.GetMissingTimesheets,
    name: Reminder.Timesheets.ForSubmission.GetMissingTimesheets.Name,
    component: async () => import("Dashboard/components/Reminders/Summary/RecruitmentAgencyAdministrationRole/ForSubmission/GetMissingTimesheetsForSubmission.vue"),
  },
  {
    path: App.Reminders.Timesheets.ForAuthorisation.GetPendingTimesheets,
    name: Reminder.Timesheets.ForAuthorisation.GetPendingTimesheets.Name,
    component: async () => import("Dashboard/components/Reminders/Summary/RecruitmentAgencyAdministrationRole/ForAuthorisation/GetPendingTimesheets.vue"),
  },
];
